import { useContext } from "react";
import { ConfettiContext } from "./context";

export function useConfetti() {
    return useContext(ConfettiContext);
}
